import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PrintIcon(props: IconProps) {
    return <Icon {...props} iconKey={"print"}/>
}
